import { ReactiveJsonRoot } from '@ea-lab/reactive-json'

/**
 * OrbitChrome — wraps any `component` route in the Orbit app chrome (the top
 * navigation menu), so a view that is NOT a reactive-json page still renders
 * "inside the app" like every YAML page does.
 *
 * The menu only exists as a reactive-json layout (`Navigation.yaml`) embedded as
 * a subroot in each page's YAML — there is no shell-level nav. A `component`
 * route (e.g. `BuilderShell`, which renders a builder `field_layout` blob in
 * React) therefore has no menu unless we mount that same layout above it. This
 * is generic shell infrastructure: it is dashboard-agnostic and reusable by any
 * future component route that wants the app menu.
 *
 * `plugins` must be the app-wide reactive-json collection (passed from the route
 * renderer) so the menu's templates/components resolve.
 */
export const OrbitChrome = ({ plugins, children }) => (
  <div className="min-h-screen flex flex-col bg-gray-50">
    <ReactiveJsonRoot
      rjBuildUrl="/components/layout/Navigation.yaml"
      rjBuildFetchMethod="GET"
      plugins={plugins}
    />
    <main className="flex-1 min-h-0 flex flex-col">{children}</main>
  </div>
)
